import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getAssets } from 'src/api/stoApi';
import { Asset } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export interface IUseAssetsResponse {
  primaryAssets: Asset[] | null;
  secondaryAssets: Asset[] | null;
}

export const useAssets = (triggerReload: boolean): IUseAssetsResponse => {
  const [primaryAssets, setPrimaryAssets] = useState<Asset[] | null>(null);
  const [secondaryAssets, setSecondaryAssets] = useState<Asset[] | null>(null);
  useEffect(() => {
    const load = async () => {
      try {
        // first check browser store
        const storageAssets = localStorage.getItem('assets');
        if (storageAssets) {
          const assets = JSON.parse(storageAssets) as Asset[];
          setPrimaryAssets(assets.filter((asset) => asset.investmentDetails.stage !== 'secondary'));
          setSecondaryAssets(assets.filter((asset) => asset.investmentDetails.stage === 'secondary'));

          // call API in the background and if the hash was different, update the store
          console.time('getAssets');
          const { data } = await getAssets();
          localStorage.setItem('assets', JSON.stringify(data));
          setPrimaryAssets(data.filter((asset) => asset.investmentDetails.stage !== 'secondary'));
          setSecondaryAssets(data.filter((asset) => asset.investmentDetails.stage === 'secondary'));
          console.timeEnd('getAssets');
        } else {
          // call API in the background and if the hash was different, update the store
          generalStore.setIsLoading(true);
          console.log('no assets in store, fetching from API');
          console.time('getAssets');
          const { data } = await getAssets();
          localStorage.setItem('assets', JSON.stringify(data));
          setPrimaryAssets(data.filter((asset) => asset.investmentDetails.stage !== 'secondary'));
          setSecondaryAssets(data.filter((asset) => asset.investmentDetails.stage === 'secondary'));
          console.timeEnd('getAssets');
        }
        // now in the background fetch from API
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, [triggerReload]);

  return { primaryAssets, secondaryAssets };
};
